import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {DialogWidth, RefModelStoreService, ThemePalette} from '@q9elements/ui-kit/common';
import {ShareRefModelDialogComponent} from '@q9elements/ui-kit/refmodels';

@Injectable({
  providedIn: 'root'
})
export class ShareRefModelDialogService {
  constructor(
    private dialog: MatDialog,
    private rmeStore: RefModelStoreService,
    private router: Router
  ) {}

  public openRefModelShareDialog() {
    const sfOrg = {
      refModelId: this.rmeStore.refModel._id || this.rmeStore.refModel.refModelId,
      refModelName: this.rmeStore.refModel.name,
      ref: this.router.url
    };

    return this.dialog
      .open(ShareRefModelDialogComponent, {
        width: DialogWidth.LG,
        data: {
          color: ThemePalette.PRIMARY,
          refModelId: sfOrg.refModelId,
          refModelName: sfOrg.refModelName,
          confirmText: 'CORE.MAP.INVITE_MODAL_BTN_INVITE',
          ref: sfOrg.ref
        }
      })
      .afterClosed();
  }
}
